import { render, staticRenderFns } from "./LanguageSelect.vue?vue&type=template&id=007cc8fb&scoped=true"
import script from "./LanguageSelect.vue?vue&type=script&lang=js"
export * from "./LanguageSelect.vue?vue&type=script&lang=js"
import style0 from "./LanguageSelect.vue?vue&type=style&index=0&id=007cc8fb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "007cc8fb",
  null
  
)

export default component.exports